module.exports = __webpack_public_path__ + "static/media/iv_my_queries.575e08fe.svg";